/**
 * Centralised environment configuration.
 * Import from here instead of reading import.meta.env directly.
 */

export const APP_ENV = import.meta.env.VITE_APP_ENV || 'development';

export const isProduction = APP_ENV === 'production';
export const isStaging = APP_ENV === 'staging';
export const isDevelopment = APP_ENV === 'development';
export const isDemo = APP_ENV === 'demo';

export const isBugLoggingEnabled = import.meta.env.VITE_BUG_LOGGING === 'true';

export const webhookBaseUrl = import.meta.env.VITE_WEBHOOK_BASE_URL || '';

export const notificationEmailOverride = import.meta.env.VITE_NOTIFICATION_EMAIL_OVERRIDE || '';

// Stable staging URL — driven by VITE_STAGING_URL env var set in Vercel per-branch settings.
// Fallback: the subdomain we're adding. Never use the raw *.vercel.app preview URL in code.
export const stagingUrl = import.meta.env.VITE_STAGING_URL || 'https://staging.kanfy.io';

// OpenPanel product analytics (src/lib/analytics/openpanel.ts). Both empty
// by default, which turns the SDK off entirely. The client id comes from the
// OpenPanel project settings; the API URL points at a self-hosted instance
// (http://localhost/api for the local docker-compose install) and is left
// empty to use OpenPanel cloud.
export const openPanelClientId = import.meta.env.VITE_OPENPANEL_CLIENT_ID || '';
export const openPanelApiUrl = import.meta.env.VITE_OPENPANEL_API_URL || '';

// Native (Capacitor) build, produced by the kanfy-mobile repository with
// VITE_PLATFORM=native. A compile-time constant: Vite pins it in vite.config.ts,
// so `isNative ? a : b` folds and the other branch leaves the bundle.
export const isNative = import.meta.env.VITE_PLATFORM === 'native';

// What the Android WebView cannot do: a blob download and window.print both
// do nothing there, so a file goes to the share sheet instead (saveOrShareFile)
// and Print buttons are not offered. A capability, so callers need not read
// isNative.
export const canDownloadAndPrint = !isNative;
